import Image from 'next/image';
import React from 'react';

/**
 * SectionDescription Component
 * Description about Mitra and Agent Pekalen Rafting
 */
const SectionDescription: React.FC = () => {
  const illustrationUrl = "/image/Vector2.webp";

  return (
    <div
      className="lg:py-12 md:py-8 py-8 lg:px-0 md:px-12 px-0 flex justify-center overflow-hidden max-w-6xl mx-auto"
    >
      <div className=" w-full flex lg:gap-12 md:gap-12 gap-5 md:items-start items-center md:flex-row flex-col">
        {/* Left Content */}
        <div       
          data-aos="fade-right"
          data-aos-delay="200"
          className="flex-1 flex flex-col gap-4 max-w-[600px] md:text-left text-center lg:px-0 md:px-0 px-6 ">
          <h2 className="font-bold  lg:text-[40px] md:text-[32px] text-[24px] tracking-[0.4px] text-[#222222] m-0">
            Mitra dan Agent Pekalen Rafting
          </h2>

          <p className="font-family-open-sans font-normal lg:text-[16px] md:text-[14px] text-[13px] leading-7 tracking-[0.16px] text-[#666666] m-0">
            Ini adalah program kemitraan penjualan paket arung jeram di Sungai Pekalen. Anda fokus pada promosi dan agen yang Anda rekrut, kami menyiapkan jadwal, perlengkapan, dan pemandu. Komisi dibayarkan untuk setiap order yang berhasil.
            <br />
            <br />
           Agent Pekalen Rafting adalah penjual langsung ke customer. Tugas Anda mempromosikan Pekalen Rafting, mengedukasi calon tamu, dan menjadikan mereka melakukan pemesanan. Komisi dihitung dari jumlah tamu yang berhasil Anda bawa. Anda menerima komisi per tamu, serta materi promosi resmi dan dukungan operasional.
            <br />
            <br />
            Mitra Pekalen Rafting adalah mereka yang sudah merekrut minimal 1 Agent. Tugas Anda merekrut, membina, dan memantau kinerja agent. Komisi dihitung dari total hasil penjualan dari agent yang Anda rekrut. Anda menerima komisi dan insentif dari performa agen yang Anda rekrut.
          </p>
        </div>

        {/* Right Content */}
        <div 
          data-aos="zoom-in"
          data-aos-delay="300"
          className="flex-1 flex lg:flex-col md:flex-col flex-col-reverse items-start font-family-open-sans">
          {/* Illustration */}
           <div className="w-full h-fit flex items-center justify-center  ">
            <Image
              width={500}
              height={500}
              src={illustrationUrl}
              alt="Illustration"
              className="w-full lg:h-[333px] md:h-[217px] h-[500px] object-contain lg:scale-100 md:scale-100 scale-170"
              quality={75}
              sizes="(min-width: 1024px) 500px, (min-width: 768px) 400px, 500px"
            />
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-0 w-full items-center justify-around flex-wrap text-center">
            <div
              data-aos="zoom-in"
              data-aos-delay="400"
              className="flex flex-col grid-cols-1 items-center rounded-xl">
              <p className=" font-bold lg:text-[64px] md:text-[52px] text-[48px] text-[#222222] text-center m-0">
                5%
              </p>
              <p className=" font-semibold text-base  text-[#222222] m-0">
                Komisi Mitra
              </p>
            </div>

            <div
              data-aos="zoom-in"
              data-aos-delay="600"
              className="flex flex-col grid-cols-1 items-center rounded-xl">
              <p className=" font-bold lg:text-[64px] md:text-[52px] text-[48px] text-[#222222] text-center m-0">
                20%
              </p>
              <p className=" font-semibold md:text-[16px] text-base  text-[#222222] m-0">
                Komisi Agen
              </p>
            </div>

             <div
              data-aos="zoom-in"
              data-aos-delay="800"
              className="flex flex-col grid-cols-1 items-center rounded-xl">
              <p className=" font-bold  lg:text-[64px] md:text-[52px] text-[48px] text-[#222222] text-center m-0">
                500+
              </p>
              <p className=" font-semibold text-base md:text-[16px]  text-[#222222] m-0">
                Partner Aktif
              </p>
            </div>

            <div
              data-aos="zoom-in"
              data-aos-delay="1000"
              className="flex flex-col grid-cols-1 items-center rounded-xl">
              <p className=" font-bold lg:text-[64px] md:text-[52px] text-[48px] text-[#222222] text-center m-0">
                50M+
              </p>
              <p className=" font-semibold text-base md:text-[16px]  text-[#222222] m-0">
                Total Komisi Dibayar
              </p>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default SectionDescription;
